var e = require("react");

module.exports = function (r) {
  return function () {
    for (var n = arguments, t = arguments.length, u = new Array(t), a = 0; a < t; a++) {
      u[a] = n[a];
    }

    var f = function f() {
      return r.removeEventListener.apply(r, u);
    };

    return e.useEffect(function () {
      if (!(!r instanceof EventTarget)) return r.addEventListener.apply(r, u), f;
    }, []), [r, f];
  };
};